








import { defineComponent } from '@vue/composition-api';

import CommonFormWithTempDeliveryEditor from '@/components/Delivery/TempDelivery/CommonFormWithTempDeliveryEditor.vue';

const CreateDeliveryFromTemp = defineComponent({
  components: {
    CommonFormWithTempDeliveryEditor,
  },
  // setup() {},
});

export default CreateDeliveryFromTemp;
